import $ from 'jquery';

export default function addStickyNavBarAndCourseCTA() {
    var featuredCourseSticky = $('.course-details-sticky');

    if ($(window).scrollTop() >= 600) {
        featuredCourseSticky.addClass('visible');
    } else {
        featuredCourseSticky.removeClass('visible');
    }
}
